import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledActionsWrapper = styled(FlexCenter)`
  cursor: pointer;
`;
